import { Plan } from '~/lib/types/Plan'

export const createPlanMock = (mock?: Partial<Plan>): Plan => {
  return {
    planName: mock?.planName ?? '特別プラン（３ヶ月）',
    isRecruitmentFeePlan: mock?.isRecruitmentFeePlan ?? false,
    isRunning: mock?.isRunning === false ? false : true,
  }
}
